<!-- 详细页:命盘 -->
<template>
    <div class="layout-detail-fate dsp-flex" v-bind:class="'column-fate-' + (fateData.length + (fateSideData ? fateSideData.length : 0))">
        <column-item class="column-bl-white"
            v-for="(data, index) in fateData"
            v-bind:key="'fate' + data.id + Math.random(0, 10)"
            v-bind:ColumnData="data"
            v-bind:columnFateData="fateInfo"
            v-bind:hasSexIcon="index == 2"
            v-bind:clickFunc="clickItem">
        </column-item>
        <column-item class="column-bl" v-show="!hideSideBar" 
            v-for="data in fateSideData" 
            v-bind:key="'fate-side' + data.id + Math.random(0, 10)"
            v-bind:ColumnData="data"
            v-bind:columnFateData="{}"
            v-bind:closeFunc="clickSideClose"
            v-bind:hasClose="true">
        </column-item>
    </div>
</template>

<script>
import ColumnItem from '../../components/ColumnItem.vue'
export default {
    name: 'DetailFate',
    props: [
        'hideSideBar',
        'fateData',
        'fateSideData',
        'fateInfo',
        'sideCloseFunc',
        'arrowFunc'
    ],
    computed: {},
    components: { ColumnItem },
    methods:{
        clickItem() {
            this.$store.dispatch('setting/toggleSetHideTypes')
        },
        clickSideClose(data) {
            if(typeof(this.sideCloseFunc) == 'function') {
                this.sideCloseFunc(data);
            }
            this.$bus.emit('resetFortune')
        }
    }
}
</script>